/**
 * Avatars du Grand Quiz du Lair : plusieurs univers dans une fenêtre de choix.
 * Valeurs enregistrées : « sonic » (roster Sonic du site), « pk:25 » (Pokémon), « an:5 » (animés).
 * Images : roster Sonic du site, illustrations officielles via PokéAPI, portraits AniList.
 */
import React, { useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { Avatar as RosterAvatar, ROSTER, rosterEntry } from './SonicRoster';

const PK = [[25, 'Pikachu'], [1, 'Bulbizarre'], [4, 'Salamèche'], [7, 'Carapuce'], [133, 'Évoli'], [6, 'Dracaufeu'], [9, 'Tortank'], [3, 'Florizarre'], [150, 'Mewtwo'], [151, 'Mew'],
  [94, 'Ectoplasma'], [143, 'Ronflex'], [39, 'Rondoudou'], [52, 'Miaouss'], [54, 'Psykokwak'], [129, 'Magicarpe'], [130, 'Léviator'], [132, 'Métamorph'], [196, 'Mentali'], [197, 'Noctali'], [700, 'Nymphali'],
  [249, 'Lugia'], [254, 'Jungko'], [257, 'Braségali'], [260, 'Laggron'], [282, 'Gardevoir'], [340, 'Barbicha'], [384, 'Rayquaza'], [445, 'Carchacrok'], [448, 'Lucario'], [658, 'Amphinobi'],
  [778, 'Mimiqui'], [887, 'Lanssorien'],
  [26, 'Raichu'], [37, 'Goupix'], [38, 'Feunard'], [59, 'Arcanin'], [65, 'Alakazam'], [68, 'Mackogneur'], [76, 'Grolem'], [95, 'Onix'], [104, 'Osselait'], [124, 'Lippoutou'],
  [131, 'Lokhlass'], [134, 'Aquali'], [135, 'Voltali'], [136, 'Pyroli'], [144, 'Artikodin'], [145, 'Électhor'], [146, 'Sulfura'], [149, 'Dracolosse'], [152, 'Germignon'], [155, 'Héricendre'],
  [158, 'Kaiminus'], [172, 'Pichu'], [175, 'Togepi'], [181, 'Pharamp'], [212, 'Cizayox'], [215, 'Farfuret'], [248, 'Tyranocif'], [250, 'Ho-Oh'], [251, 'Celebi'], [252, 'Arcko'],
  [255, 'Poussifeu'], [258, 'Gobou'], [302, 'Ténéfix'], [359, 'Absol'], [373, 'Drattak'], [380, 'Latias'], [381, 'Latios'], [382, 'Kyogre'], [383, 'Groudon'], [387, 'Tortipouss'],
  [390, 'Ouisticram'], [393, 'Tiplouf'], [405, 'Luxray'], [428, 'Lockpin'], [470, 'Phyllali'], [471, 'Givrali'], [475, 'Gallame'], [483, 'Dialga'], [484, 'Palkia'], [487, 'Giratina'],
  [491, 'Darkrai'], [493, 'Arceus'], [571, 'Zoroark'], [609, 'Lugulabre'], [635, 'Trioxhydre'], [643, 'Reshiram'], [644, 'Zekrom'], [722, 'Brindibou'], [725, 'Flamiaou'], [727, 'Félinferno'],
  [728, 'Otaquin'], [745, 'Lougaroc'], [800, 'Necrozma'], [810, 'Ouistempo'], [813, 'Flambino'], [816, 'Larméléon'], [906, 'Poussacha'], [909, 'Chochodile'], [912, 'Coiffeton'], [1007, 'Koraidon'], [1008, 'Miraidon']];
const PK_URL = (id) => `https://cdn.jsdelivr.net/gh/PokeAPI/sprites@master/sprites/pokemon/other/official-artwork/${id}.png`;
const PK_ALT = (id) => `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`;

const AL = 'https://s4.anilist.co/file/anilistcdn/character/large/';
const AN = [
  [5, 'Ichigo', 'b5-a7bkJgjhhigE.png'], [6, 'Rukia', 'b6-25WoBeWMZXBc.png'], [1086, 'Aizen', 'b1086-qR9218BjZTC0.png'], [17, 'Naruto', 'b17-phjcWCkRuIhu.png'], [13, 'Sasuke', 'b13-SISLEw1oAD7a.png'],
  [85, 'Kakashi', 'b85-mkVBh2yjxjmx.png'], [40, 'Luffy', 'b40-MNypXsxSRb1R.png'], [62, 'Zoro', 'b62-S7oAeA9WInjV.png'], [11, 'Edward', 'b11-TA5Nuk7EDUZG.jpg'], [12, 'Alphonse', 'b12-tCKu8yK5kFL5.jpg'],
  [68, 'Roy Mustang', 'b68-moBLY2WO2am3.png'], [176754, 'Frieren', 'b176754-PCnpqIOkjhFk.png'], [183965, 'Fern', 'b183965-uGFohBjlFoTp.png'], [184313, 'Stark', 'b184313-CQl6GSt4RSny.jpg'],
  [138100, 'Anya', 'b138100-4Li0tWRCa5bQ.png'], [138101, 'Loid', 'b138101-7NCB0Md8zA6G.png'], [138102, 'Yor', 'b138102-ZOAu9jI2d5ke.png'], [126824, 'Maomao', 'b126824-MqsCncTO1qpv.png'],
  [120649, 'Kaguya', 'b120649-NPaWaIpWy60E.png'], [121101, 'Shirogane', 'b121101-Q8HzKP15At2d.png'], [64769, 'Hinata', 'b64769-WoWlCMLLgJ14.png'], [64771, 'Kageyama', 'b64771-BuCVs7B8bBdh.png'],
  [4003, 'Jotaro', 'b4003-gWDSEGbeOAll.png'], [10529, 'Giorno', 'b10529-AloL8jjZwjsg.png'], [417, 'Lelouch', 'b417-gVLmIJu9phcK.png'], [422, 'Guts', 'b422-XTaiTuvRohsV.png'], [124142, 'Senku', 'b124142-XUO1g7wRqkaT.png'],
  [257562, 'Bocchi', 'b257562-Ru35NYPfsqhY.png'], [434, 'Onizuka', 'b434-Q0K9e4HukawA.png'], [18769, 'Kuroko', 'b18769-1SOeKdgkjBef.png'], [310, 'Sakuragi', 'b310-3GLKM2I3EiRf.png'], [16412, 'Mark Evans', 'b16412-ZsvITu2WWg6Q.jpg'],
  [507, 'Hauru', 'b507-g9yz1GTLtPla.jpg'], [498, 'Rin Tohsaka', 'b498-lwawtSpLyATL.png'], [1, 'Spike', 'b1-ChxaldmieFlQ.png'], [284158, 'David', 'b284158-z1uGKC3IYVa1.png'], [390, 'Mugen', 'b390-30DZg8NvIrVk.png'],
  [127221, 'Sakuta', 'n127221-Wxg4xFtW4kaJ.png'], [133676, 'Marin', 'b133676-kV2czE3C8Qls.png'],
  [723, 'Nami', 'b723-vp5hPptgnNEC.png'], [305, 'Sanji', 'b305-6lisPmHtCnLT.png'], [724, 'Usopp', 'b724-GFGgI9AJQkfy.jpg'], [309, 'Chopper', 'b309-H64NhbJ2ywIQ.jpg'], [61, 'Nico Robin', 'b61-ywXUyyocEEqt.png'],
  [727, 'Shanks', 'b727-wUJx7M1z5xON.png'], [2072, 'Ace', 'b2072-Lc6jEdsueJUK.jpg'], [13767, 'Law', 'b13767-U604OJN9dxCn.jpg'], [907, 'Byakuya', 'b907-kgnDKeMtEN5y.png'], [909, 'Kenpachi', 'b909-slhoFBon7oiH.jpg'],
  [245, 'Hitsugaya', 'b245-buy3Cfn6IFSB.jpg'], [210, 'Urahara', 'b210-mw01NrQfRjzT.png'], [1080, 'Grimmjow', 'b1080-JUNo2Or0UGZg.jpg'], [1081, 'Ulquiorra', 'b1081-xLTqHfLL2I2W.png'], [14, 'Itachi', 'b14-9Kb1E5oel1ke.png'],
  [1662, 'Gaara', 'b1662-4E5J0LX9jZKZ.png'], [145, 'Sakura', 'b145-IorfpI8arxeX.png'], [2423, 'Jiraiya', 'b2423-RO5MyoXSA9OL.png'], [63, 'Winry', '63-xloedtYxiJ2E.jpg'], [70, 'Riza Hawkeye', 'b70-k4bCgDspyOdI.png'],
  [651, 'Envy', 'b651-S4mzVOTMzej6.png'], [4004, 'Dio', 'b4004-w0OtWuvjhftG.png'], [13085, 'Josuke', 'b13085-CkmgXL7SSLxL.jpg'], [6356, 'Joseph Joestar', 'b6356-RImEfUfHpC58.png'], [71267, 'Kenma', 'b71267-q44J2MXMinXD.jpg'],
  [71611, 'Oikawa', 'b71611-cUZwVfzeNXD9.png'], [88937, 'Bokuto', 'b88937-2GSqkX9TIzYy.png'], [71269, 'Kuroo', 'b71269-pi9vjyxKPFAu.jpg'], [121103, 'Chika Fujiwara', 'b121103-UGLxT8utLPnq.png'], [184311, 'Himmel', 'b184311-wQFySqYXEqf1.png'],
  [127278, 'Jinshi', 'b127278-0qCQciTkPOMS.jpg'], [1111, 'C.C.', 'b1111-UhmlFtRFrnWa.png'], [559, 'Suzaku', 'b559-KRvTdc6zdCuU.jpg'], [424, 'Griffith', 'b424-Jfrsf8I7zBps.png'], [423, 'Casca', 'b423-AmVFCaJJOBsc.png'],
  [18770, 'Kagami', 'b18770-iLAk9O3GGUvN.png'], [42038, 'Akashi', 'b42038-3xNprwetDcl1.jpg'], [124145, 'Chrome', 'b124145-EEvQmsj8jku4.png'], [261674, 'Nijika', 'b261674-a8tJYvtzqWgC.png'], [264529, 'Ryo', 'b264529-BvEusZnJLD2Y.png'],
  [266041, 'Kita', 'b266041-1HKgjJGP2MmM.png'], [284163, 'Rebecca', 'b284163-tt8smoAXl24x.jpg'], [2, 'Faye Valentine', 'b2-0Iszg6Izgt4p.png'], [497, 'Saber', 'b497-Yg5pNmC8kxzs.png'], [2514, 'Archer', 'b2514-hnE6LEdqm7Su.png'],
  [123962, 'Rimuru', 'b123962-eL9yGV0NLMF7.png'], [137260, 'Gabimaru', 'b137260-xmSis8FmwhEE.png'], [204522, 'Odokawa', 'b204522-tiKCzn4Wxpys.png'], [128651, 'Hanako', 'b128651-GaZImkP2Of1R.png'], [266372, 'Takopi', 'b266372-zUgh0xxukbW8.png'],
  [16413, 'Axel Blaze', 'b16413-CpiNlFdblxau.png'], [269, 'Totoro', 'b269-sbPL4w1ygjSe.jpg'], [384, 'Chihiro', 'b384-AoWCsQyG0WI7.png'], [672, 'San', 'b672-cP5VPriN67xJ.png'], [89028, 'Deku', 'b89028-8w1I9o1ISHMg.png'],
  [88892, 'Bakugo', 'b88892-bdOha3lNcaN6.png'], [89224, 'All Might', 'b89224-K6KEuQAuYKzq.jpg']
];

const SB = [
  ['Mario', 'Mario', '4/44'],
  ['Luigi', 'Luigi', 'b/bb'],
  ['Peach', 'Peach', '7/74'],
  ['Daisy', 'Daisy', '2/21','6aebc3bea9797692fa6a3945'],
  ['Bowser', 'Bowser', '4/49'],
  ['Bowser Jr.', 'Bowser Jr.', '2/2b','6aebc3bba9797692fa6a3937'],
  ['Yoshi', 'Yoshi', '8/8d'],
  ['Rosalina & Luma', 'Harmonie', '1/16'],
  ['Wario', 'Wario', '0/04'],
  ['Dr. Mario', 'Dr. Mario', '3/3f'],
  ['Piranha Plant', 'Plante Piranha', 'f/f0'],
  ['Donkey Kong', 'Donkey Kong', 'c/c9'],
  ['Diddy Kong', 'Diddy Kong', 'a/a7'],
  ['King K. Rool', 'King K. Rool', 'b/b6'],
  ['Link', 'Link', '8/84'],
  ['Zelda', 'Zelda', 'c/c8'],
  ['Sheik', 'Sheik', '0/00'],
  ['Ganondorf', 'Ganondorf', '9/91'],
  ['Young Link', 'Link enfant', '8/8a','6aebc3c0a9797692fa6a394f'],
  ['Toon Link', 'Link Cartoon', '5/56'],
  ['Kirby', 'Kirby', '0/07'],
  ['Meta Knight', 'Meta Knight', '0/00'],
  ['King Dedede', 'Roi Dadidou', 'f/f5'],
  ['Samus', 'Samus', '0/03'],
  ['Zero Suit Samus', 'Zero Suit Samus', 'f/f0','6aebc3c0a9797692fa6a3951'],
  ['Dark Samus', 'Samus sombre', 'a/a6'],
  ['Ridley', 'Ridley', '2/27'],
  ['Fox', 'Fox', '2/2f'],
  ['Falco', 'Falco', '8/80'],
  ['Wolf', 'Wolf', '8/8a'],
  ['Marth', 'Marth', 'e/e9','6aebc3bfa9797692fa6a394b'],
  ['Lucina', 'Lucina', 'd/dc','6aebc3bfa9797692fa6a3949'],
  ['Roy', 'Roy', '9/9d'],
  ['Chrom', 'Chrom', '5/57'],
  ['Ike', 'Ike', '8/86'],
  ['Robin', 'Robin', '8/82'],
  ['Corrin', 'Corrin', 'c/c4','6aebc3bba9797692fa6a3939'],
  ['Byleth', 'Byleth', '3/3d'],
  ['Ness', 'Ness', '8/82'],
  ['Lucas', 'Lucas', '8/81','6aebc3c0a9797692fa6a3955'],
  ['Captain Falcon', 'Captain Falcon', 'd/da'],
  ['Pit', 'Pit', '3/38'],
  ['Dark Pit', 'Pit maléfique', '0/09'],
  ['Palutena', 'Palutena', '6/6b'],
  ['Olimar', 'Olimar', 'b/b3','6aebc3c1a9797692fa6a3957'],
  ['Villager', 'Villageois', 'a/ac'],
  ['Isabelle', 'Marie', '2/2b'],
  ['Inkling', 'Inkling', '2/2e'],
  ['Ice Climbers', 'Ice Climbers', '1/12'],
  ['Mr. Game & Watch', 'Mr. Game & Watch', 'c/cb'],
  ['R.O.B.', 'R.O.B.', '6/60','6aebc3c1a9797692fa6a395b'],
  ['Duck Hunt', 'Duck Hunt', 'd/d8','6aebc3bca9797692fa6a393b'],
  ['Little Mac', 'Little Mac', '5/53'],
  ['Wii Fit Trainer', 'Entraîneuse Wii Fit', 'f/ff'],
  ['Shulk', 'Shulk', '0/0f'],
  ['Pyra', 'Pyra', 'e/ec'],
  ['Mythra', 'Mythra', '5/58'],
  ['Min Min', 'Min Min', '3/35'],
  ['Pikachu', 'Pikachu', '9/93','6aebc3baa9797692fa6a3935'],
  ['Pichu', 'Pichu', 'c/c1','6aebc3bfa9797692fa6a394d'],
  ['Jigglypuff', 'Rondoudou', '6/6a','6aebc3bea9797692fa6a3947'],
  ['Mewtwo', 'Mewtwo', 'd/de'],
  ['Lucario', 'Lucario', '0/08'],
  ['Greninja', 'Amphinobi', 'd/da','6aebc3bca9797692fa6a393d'],
  ['Incineroar', 'Félinferno', 'c/c4'],
  ['Pokémon Trainer', 'Dresseur Pokémon', '0/0f'],
  ['Sonic', 'Sonic', 'b/ba'],
  ['Snake', 'Snake', '0/02'],
  ['Mega Man', 'Mega Man', '4/46','6aebc3bca9797692fa6a393f'],
  ['Pac-Man', 'Pac-Man', '0/03','6aebc3bda9797692fa6a3941'],
  ['Ryu', 'Ryu', '6/61','6aebc3bda9797692fa6a3943'],
  ['Ken', 'Ken', 'f/f6'],
  ['Cloud', 'Cloud', 'b/b3'],
  ['Sephiroth', 'Sephiroth', '4/49'],
  ['Bayonetta', 'Bayonetta', '7/7c'],
  ['Simon', 'Simon', '9/95'],
  ['Richter', 'Richter', 'c/c2'],
  ['Joker', 'Joker', '5/5c'],
  ['Hero', 'Héros', '0/07'],
  ['Banjo & Kazooie', 'Banjo & Kazooie', '9/97'],
  ['Terry', 'Terry', 'f/f5'],
  ['Steve', 'Steve', '3/3a'],
  ['Kazuya', 'Kazuya', 'd/d9'],
  ['Sora', 'Sora', '2/2d']
];
// Rendus officiels de SmashWiki (vignettes 480 px) ; les fichiers trop lourds sont des copies réduites hébergées sur le site
const SB_URL = (name, h, media) => { if (media) return `/api/quizshow/media/${media}`; const f = encodeURI(`${name.replace(/ /g, '_')}_SSBU.png`); return `https://ssb.wiki.gallery/images/thumb/${h}/${f}/480px-${f}`; };

export const UNIVERSES = [
  { id: 'sonic', name: 'Sonic', icon: '💨', list: ROSTER.map((r) => ({ v: r.id, name: r.name })) },
  { id: 'pk', name: 'Pokémon', icon: '⚡', list: PK.map(([id, name]) => ({ v: `pk:${id}`, name, src: PK_URL(id), alt: PK_ALT(id) })) },
  { id: 'an', name: 'Animés', icon: '🌸', list: AN.map(([id, name, f]) => ({ v: `an:${id}`, name, src: AL + f })) },
  { id: 'sb', name: 'Smash Bros', icon: '🥊', list: SB.map(([key, name, h, full]) => ({ v: `sb:${key}`, name, src: SB_URL(key, h, full) })) }
];
const ALL = new Map(UNIVERSES.flatMap((u) => u.list.map((x) => [x.v, { ...x, u: u.id }])));
export const avatarInfo = (v) => ALL.get(v) || null;
export const randomAvatar = () => { const l = [...ALL.keys()]; return l[Math.floor(Math.random() * l.length)]; };

/** Pastille d'avatar pour n'importe quel univers (ou une image libre pour les anciennes parties). */
export function AnyAvatar({ v, name, size = 56, mediaUrl }) {
  const [bad, setBad] = useState(0);
  if (v && rosterEntry(v)) return <span className="qs-avatar is-roster" style={{ width: size, height: size }}><RosterAvatar id={v} size={size} fallbackName={name} /></span>;
  const info = avatarInfo(v);
  const first = info ? info.src : v && /^(https?:|\/)/.test(v) ? (mediaUrl ? mediaUrl(v) : v) : '';
  const src = bad === 1 && info?.alt ? info.alt : first;
  const dead = bad >= (info?.alt ? 2 : 1);
  if (src && !dead) return <img key={src} className={`qs-avatar${info && (info.u === 'pk' || info.u === 'sb') ? ' is-pk' : ''}`} src={src} alt={info ? info.name : name} referrerPolicy="no-referrer" onError={() => setBad((b) => b + 1)} style={{ width: size, height: size }} />;
  return <span className="qs-avatar is-initials" style={{ width: size, height: size }}>{(name || info?.name || '?').slice(0, 2).toUpperCase()}</span>;
}

/** Fenêtre de choix : un onglet par univers, recherche, grille. */
export function AvatarModal({ value, onPick, onClose }) {
  const [tab, setTab] = useState(() => avatarInfo(value)?.u || 'sonic');
  const [q, setQ] = useState('');
  const u = UNIVERSES.find((x) => x.id === tab);
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return u.list;
    return UNIVERSES.flatMap((x) => x.list).filter((x) => x.name.toLowerCase().includes(s));
  }, [q, u]);
  // Rendu à la racine de la page : un parent animé (transform, filtre) piégerait la fenêtre
  const host = (typeof document !== 'undefined' && document.querySelector('.qs-root')) || document.body;
  return createPortal(
    <div className="qs-modal" onClick={onClose} role="presentation">
      <div className="qs-modal-box" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Choisir un personnage">
        <header>
          <h3>Choisis ton personnage</h3>
          <button type="button" className="qs-modal-x" onClick={onClose} aria-label="Fermer">✕</button>
        </header>
        <div className="qs-modal-tabs">
          {UNIVERSES.map((x) => <button type="button" key={x.id} className={x.id === tab && !q ? 'is-on' : ''} onClick={() => { setTab(x.id); setQ(''); }}><span>{x.icon}</span>{x.name}<small>{x.list.length}</small></button>)}
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher…" />
        </div>
        <div className="qs-modal-grid">
          {list.map((x) => (
            <button type="button" key={x.v} className={`qs-av-slot${x.v === value ? ' is-mine' : ''}`} onClick={() => { onPick(x.v); onClose(); }}>
              <AnyAvatar v={x.v} name={x.name} size={64} />
              <span>{x.name}</span>
            </button>
          ))}
          {!list.length && <p className="qs-muted">Aucun personnage trouvé.</p>}
        </div>
      </div>
    </div>,
    host
  );
}

/** Portrait de présentateur, en grand. */
export function Portrait({ v, name }) {
  const [bad, setBad] = useState(0);
  if (v && rosterEntry(v)) return <div className="qs-portrait is-roster"><RosterAvatar id={v} size={210} fallbackName={name} /></div>;
  const info = avatarInfo(v);
  const src = bad === 1 && info?.alt ? info.alt : info ? info.src : v && /^(https?:|\/)/.test(v) ? v : '';
  const dead = bad >= (info?.alt ? 2 : 1);
  return (
    <div className={`qs-portrait${info && (info.u === 'pk' || info.u === 'sb') ? ' is-pk' : ''}`}>
      {src && !dead ? <img key={src} src={src} alt={name} referrerPolicy="no-referrer" onError={() => setBad((b) => b + 1)} /> : <span>{(name || '?').slice(0, 2).toUpperCase()}</span>}
    </div>
  );
}
